interface AppElements {
  container: SVGElement
  use: SVGUseElement
}

export class AppIcon extends HTMLElement {
  static observedAttributes = ['name', 'size']
  #spriteUrl: string = this.getSpriteUrl()
  #el: AppElements = {
    container: document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
    use: document.createElementNS('http://www.w3.org/2000/svg', 'use'),
  }

  constructor() {
    super()
  }

  connectedCallback() {
    this.#spriteUrl = this.getSpriteUrl()
    this.#render()
  }

  private getSpriteUrl(): string {
    const metaTag = document.querySelector('meta[name="data-sprite-url"]')
    return metaTag?.getAttribute('content') || '/icons/sprite.svg'
  }

  attributeChangedCallback(name: string, _oldValue: string, _newValue: string) {
    if (name === 'name') this.updateName()
    else if (name === 'size') this.updateSize()
  }

  updateSize() {
    const size = this.getAttribute('size')
    this.#el.container.classList.add(size || 'md')
  }

  updateName() {
    const name = this.getAttribute('name')
    const spriteUrl = `${this.#spriteUrl}#app-icon-${name}`
    this.#el.use.setAttribute('href', spriteUrl)
  }

  #render() {
    const svg = this.#el.container
    svg.classList.add('app-icon')
    this.updateSize()
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('height', '24')
    svg.setAttribute('width', '24')

    this.updateName()

    svg.appendChild(this.#el.use)
    this.appendChild(svg)
  }

  disconnectedCallback() {
    // Note: With arrow function in addEventListener, we can't easily remove specific listeners
    // The dialog will be removed from DOM anyway, so this cleanup is optional
  }
}

customElements.define('app-icon', AppIcon)
